import { createContext } from 'react';
import type { Viewport } from '@xyflow/react';

export type GraphContextState = {
  selectedNodeId: string | null;
  connectedIds: Set<string>;
  /** Nodes lying on a problematic circular dependency (see computeCycles). */
  cycleNodeIds: Set<string>;
  getNodeUrl: (id: string) => string | undefined;
};

export const GraphContext = createContext<GraphContextState>({
  selectedNodeId: null,
  connectedIds: new Set(),
  cycleNodeIds: new Set(),
  getNodeUrl: () => undefined,
});

export const DEFAULT_VIEWPORT: Viewport = { x: 0, y: 0, zoom: 1 };

/**
 * Compute a viewport that centers on the junction between the hook band and
 * the field band. Used by the hooks MR when fieldBandY > 0. Returns
 * DEFAULT_VIEWPORT for the current field-only layout.
 */
export const computeHomeViewport = (fieldBandY: number): Viewport => {
  if (fieldBandY === 0) return DEFAULT_VIEWPORT;
  // Show the junction area with some hooks visible above
  return { x: 0, y: -(fieldBandY - 200), zoom: 1 };
};

GraphContext.displayName = 'GraphContext';
